<template>
  <v-main>
    <v-card :ripple="false" :img="ImgCover" height="240px" width="100%">
    </v-card>
    <v-card class="pa-6 pb-10 px-0 mt-n10 mb-10" :color="DarkModeBackground"
      :style="'background-color:' + DarkModeBackground + ';min-height: 100vh;'">
      <!-- :style="'background-color:'+ DarkModeBackground +';min-height: 100vh;border-radius: 45px 45px 0px 0px;'" -->
      <v-row>
        <v-col class="text-center">
          <v-avatar class="mt-n16 pa-1" style="" :color="DarkModeBackground" size="150">
            <img :src="LoGo">
          </v-avatar>
        </v-col>
      </v-row>
      <div style="display:flex;justify-content: center;" class="ma-3">
        <v-chip class="mr-1 font-weight-black"
          :style="'background-color:' + (languageSelect === 0 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:20px'"
          dark @click="languageSelect = 0">
          <v-avatar left>
            <v-img
              src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e"></v-img>
          </v-avatar>
          TH
        </v-chip>
        <v-chip class="ml-1 font-weight-black"
          :style="'background-color:' + (languageSelect === 1 ? DarkModeButton : 'rgb(103 103 103 / 18%)') + ';font-size:20px'"
          dark @click="languageSelect = 1">
          <v-avatar left>
            <v-img
              src="https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b"></v-img>
          </v-avatar>
          EN
        </v-chip>
      </div>
      <v-row v-if="dataBookingData !== null && dataBookingData.length > 0 && dataBookingData[0].lineUserId === null">
        <v-col cols="12" class="text-center mt-4" v-if="dataLineConfig.checkConfig === false">
          <v-btn v-if="this.$route.query.shopId" elevation="10" color="green" dark @click="getBotinfo()">{{
            languageSelect === 0 ? "รับการแจ้งเตือนผ่าน Line OA" : "Get notified LINE OA" }}</v-btn>
        </v-col>
        <v-col cols="12" v-else class="text-center mt-4">
          <v-btn v-if="this.$route.query.shopId && this.$route.query.shopId.includes('SD_') === false" elevation="10"
            color="green" dark @click="getBotinfoChatAuto()">{{ languageSelect === 0 ? "รับการแจ้งเตือนผ่าน Line OA" :
            "Get notified LINE OA" }}</v-btn>
        </v-col>
      </v-row>
      <v-sheet v-if="loading">
        <div class="text-center mt-6" :style="'background-color:' + DarkModeBackground">
          <v-progress-circular indeterminate></v-progress-circular>
        </div>
      </v-sheet>
      <v-sheet v-else class="pa-3 pt-5 mt-3"
        :style="'background-color:' + DarkModeBackground + ';border-radius: 0px 0px 0px 0px;'">
        <div v-if="dataBookingData.length > 0 && dataBookingData[0].storeFrontQueue">
          <div class="pa-3" :style="'background-color:#FFFFFF;min-height: 180px;'">
            <h4 class="text-center font-weight-bold mt-5" style="color:#092C4C">{{ shop[0].shopName }}</h4>
            <h4 class="text-center font-weight-bold mt-5" v-if="dataBookingData[0].flowName" style="color:#092C4C">{{
              languageSelect === 0 ? dataBookingData[0].flowName : (dataBookingData[0].flowNameEn ||
              dataBookingData[0].flowName)}}</h4>
            <v-row>
              <v-col cols="6">
                <div class="text-left ml-6 mt-3">
                  <p class="font-weight-bold" style="color:#092C4C">{{ languageSelect === 0 ? "วันที่นัดหมาย" : "Date"
                    }}</p>
                  <p style="color:#092C4C" v-if="shouldShowBookingTime" class="font-weight-bold">{{ languageSelect === 0 ?
                    "เวลา" : "Time of issue" }}</p>
                  <p style="color:#092C4C" v-if="dataBookingData[0].servicePoint" class="font-weight-bold">{{
                    languageSelect === 0 ? "จุดบริการ" : "Service point" }}</p>
                  <p style="color:#092C4C" v-if="shopId=='U0f47529d9b295da15c3961d1a175c1e0'" class="font-weight-bold">{{ languageSelect === 0 ?
                    "เวลา" : "Time of issue" }}</p>
                </div>
              </v-col>
              <v-col cols="6">
                <div class="text-right mr-6 mt-3">
                  <p class="font-weight-bold" style="color:#092C4C">{{ momenDate_2(dataBookingData[0].dueDate) }}</p>
                  <p style="color:#092C4C" class="font-weight-bold" v-if="shouldShowBookingTime">
                    {{ momenTime(dataBookingData[0].dueDate) }}{{ languageSelect === 0 ? " น." : "" }}</p>
                  <p style="color:#092C4C" v-if="dataBookingData[0].servicePoint" class="font-weight-bold">{{
                    languageSelect === 0 ? dataBookingData[0].servicePoint :
                      JSON.parse(dataBookingData[0].servicePointCount).filter(el => {
                        return el.textTh ===
                          dataBookingData[0].servicePoint
                      }).length > 0 ?
                        JSON.parse(dataBookingData[0].servicePointCount).filter(el => {
                          return el.textTh ===
                    dataBookingData[0].servicePoint})[0].textEn:dataBookingData[0].servicePoint}}</p>
                    <p style="color:#092C4C" class="font-weight-bold" v-if="shopId=='U0f47529d9b295da15c3961d1a175c1e0'">
                      {{ momenTime(dataBookingData[0].CREATE_DATE_Status) }}{{ languageSelect === 0 ? " น." : "" }}</p>
                </div>
              </v-col>
            </v-row>
            <v-row v-for="(item, index) in visibleBookingDataUse" :key="index">
              <v-col class="text-left pb-0 pt-0" cols="6">
                <p class="font-weight-bold ml-6" style="color:#092C4C">{{ languageSelect === 0 ?
                  item.fieldName :item.fieldNameEn}}</p>
              </v-col>
              <v-col class="text-right pb-0 pt-0" cols="6">
                <p class="font-weight-bold mr-6" style="color:#092C4C" v-if="item.fieldType === 'Checkbox'">
                  {{ languageSelect === 0
                    ? (Array.isArray(JSON.parse(item.fieldValue)) ? JSON.parse(item.fieldValue).join(',') : item.fieldValue)
                    : getFieldValueEn(item) }}</p>
                <p class="font-weight-bold mr-6" style="color:#092C4C" v-else>{{ languageSelect === 0 ? item.fieldValue : getFieldValueEn(item) }}</p>
              </v-col>
            </v-row>
          </div>
          <div v-if="showQueueCard"
            class="pa-3"
            :style="queueCardStyle">
            <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ languageSelect === 0 ?
              "หมายเลขคิวของคุณ" : "Your Number" }}</h5>
            <p style="color:#092C4C;font-size: 80px;" class="text-center font-weight-black mt-n5 mb-n5">
              {{ currentBooking.storeFrontQueue }}</p>
            <div v-if="queueCardMessages.type === 'beforeQueue'"
              style="display:flex;justify-content: center;">
              <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ languageSelect === 0 ?
                "มีคิวก่อนหน้าคุณ" : "At the front of the queue" }}</h5>
              <h5
                style="color:#FFFFFF;background-color:#092C4C;min-height: 30px;width:30px;border-radius: 80px 80px 80px 80px;display: flex;justify-content: center;align-items: center;"
                class="text-center font-weight-black ml-2 mr-2 mt-2">{{ beforQueue }}</h5>
              <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ languageSelect === 0 ? "คิว" :
                "Queue" }}</h5>
            </div>
            <div v-else>
              <h5
                v-for="(message, index) in queueCardMessages.messages"
                :key="index"
                style="color:#092C4C"
                class="text-center font-weight-bold mt-2">
                {{ message }}
              </h5>
            </div>
          </div>
        </div>
        <div v-else>
          <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ languageSelect === 0 ? "ไม่มีข้อมูล" :
            "No data." }}</h5>
        </div>
      </v-sheet>
      <v-row v-if="dataBookingData.length > 0 && dataBookingData[0].statusBt !== 'cancel' && dataBookingData[0].statusBt !== 'closeJob' && dataBookingData[0].storeFrontShowBt === 'True'">
        <v-col cols="12" class="text-center mt-4" style="padding: 0;">
          <v-btn
            :loading="loadingCancel"
            :disabled="loadingCancel"
            elevation="0"
            style="background-color: #f44336; border: 2px solid #E60020; border-radius: 500px; color: white;"
            @click="checkCancel()"
          >
            {{ languageSelect === 0 ? "ยกเลิกนัดหมาย" : "Cancel Booking" }}
          </v-btn>
        </v-col>
      </v-row>
      <!-- <v-sheet v-else>
      <div v-if="loading" class="text-center mt-6" :style="'background-color:'+ DarkModeBackground">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <div v-else>
        <h5 style="color:#092C4C" class="text-center font-weight-bold mt-2">{{ languageSelect === 0 ? "ไม่มีข้อมูล" : "No data." }}</h5>
      </div>
    </v-sheet> -->
    </v-card>
    <v-footer padless fixed>
      <v-row>
        <v-col class="text-center" cols="12" v-if="shopNameData.krungthaiWesternHospital === shopId || shopNameData.krungthaiWesternHospitalPkm === shopId">
          <strong style="color:#092C4C">{{ languageSelect === 0 ? "หากท่านไม่ได้อยู่ในช่วงที่มีการเรียกคิว" : "If you are not present when your queue is called," }}</strong><br>
          <strong style="color:#092C4C">{{ languageSelect === 0 ? "สามารถแจ้งหมายเลขคิวกับพนักงาน" : "please inform our staff of your queue number" }}</strong><br>
          <strong style="color:#092C4C">{{ languageSelect === 0 ? "เพื่อยืนยันการเข้ารับบริการได้ค่ะ" : "to confirm your service." }}</strong><br>
        </v-col>
        <v-col class="text-center" cols="12" v-else>
          <strong style="color:#092C4C">{{ languageSelect === 0 ? "* ทางบริษัทขอสงวนสิทธิ์ในการข้ามคิวกรณีลูกค้าไม่แสดงตน" : "Note: Please be ready 5 minutes before the queue is coming." }}</strong>
        </v-col>
      </v-row>
    </v-footer>
    <v-dialog
      v-model="isDialogCancel"
      width="390"
      persistent
      content-class="custom-dialog"
      style="border-radius: 16px !important"
    >
      <v-card style="border-radius: 16px; overflow: hidden;">
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" class="text-center pt-3 pb-2">
              <h3 style="color: #D32F2F; font-weight: bold; font-size: 22px; line-height: 1.4;">
                {{ languageSelect === 0 ? "คุณต้องการยกเลิกนัดหมายใช่หรือไม่?" : "Do you want to cancel your appointment?" }}
              </h3>
            </v-col>

            <v-col cols="12" class="text-center pt-4 pb-2">
              <div style="display: flex; justify-content: center;">
                <div style="width: 200px; height: 200px; background: linear-gradient(135deg, #FF6B6B 0%, #EE5A6F 100%); border-radius: 12px; display: flex; align-items: center; justify-content: center; position: relative; box-shadow: 0 4px 12px rgba(211, 47, 47, 0.2);">
                  <div style="position: absolute; top: 20px; width: 160px; height: 120px; background: white; border-radius: 8px; padding: 10px;">
                    <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                      <div style="width: 30px; height: 20px; background: #FFD54F; border-radius: 4px;"></div>
                      <div style="width: 30px; height: 20px; background: #FFD54F; border-radius: 4px;"></div>
                    </div>
                    <div style="height: 3px; background: linear-gradient(90deg, #FF6B6B 0%, #EE5A6F 60%, #E91E63 100%); margin-bottom: 10px;"></div>
                    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; padding: 0 10px;">
                      <div style="width: 30px; height: 12px; background: #E3F2FD; border-radius: 2px;"></div>
                      <div style="width: 30px; height: 12px; background: #90A4AE; border-radius: 2px;"></div>
                      <div style="width: 30px; height: 12px; background: #90A4AE; border-radius: 2px;"></div>
                      <div style="width: 30px; height: 12px; background: #90A4AE; border-radius: 2px;"></div>
                      <div style="width: 30px; height: 12px; background: #90A4AE; border-radius: 2px;"></div>
                      <div style="width: 30px; height: 12px; background: #90A4AE; border-radius: 2px;"></div>
                    </div>
                  </div>
                  <div style="position: absolute; bottom: 10px; left: 20px; width: 80px; height: 80px; background: linear-gradient(135deg, #FF6B6B 0%, #EE5A6F 50%, #D32F2F 100%); border-radius: 50%; display: flex; align-items: center; justify-content: center; box-shadow: 0 4px 8px rgba(0,0,0,0.2);">
                    <v-icon size="50" color="white">mdi-close</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="text-center pt-3 pb-2">
              <p style="color: #757575; font-size: 15px; line-height: 1.5; margin: 0;">
                {{ languageSelect === 0 ? "โปรดเลือกเหตุผลที่ต้องการยกเลิก" : "Please select reason for cancellation" }}<br>
                {{ languageSelect === 0 ? "เพื่อให้เราปรับปรุงบริการได้ดีขึ้น" : "to help us improve our service" }}
              </p>
            </v-col>

            <v-col cols="12" class="text-center pt-2 pb-3">
              <div style="display: flex; flex-wrap: wrap; justify-content: center; gap: 10px;">
                <v-btn
                  v-for="(note) in Note"
                  :key="note.reason"
                  rounded
                  outlined
                  small
                  :color="selectedNote === note ? '#D32F2F' : '#E0E0E0'"
                  :style="{
                    'border': selectedNote === note ? '2px solid #D32F2F' : '1px solid #E0E0E0',
                    'background-color': selectedNote === note ? '#FFEBEE' : 'white',
                    'color': selectedNote === note ? '#D32F2F' : '#757575',
                    'font-size': '13px',
                    'text-transform': 'none',
                    'padding': '6px 16px',
                    'font-weight': selectedNote === note ? 'bold' : 'normal'
                  }"
                  @click="selectedNote = note; isboolNote = false"
                >
                  {{ languageSelect === 0 ? note.reason : note.reason_en }}
                </v-btn>
              </div>
            </v-col>

            <v-col v-if="isboolNote" cols="12" class="text-center pt-0 pb-1">
              <p style="color: #D32F2F; font-size: 13px; margin: 0;">
                {{ languageSelect === 0 ? "กรุณาเลือกเหตุผล" : "Please select a reason" }}
              </p>
            </v-col>

            <!-- <v-col cols="12" class="text-center pt-1 pb-2">
              <p style="color: #BDBDBD; font-size: 12px; margin: 0;">
                {{ languageSelect === 0 ? "เหตุผลส่วนตัว" : "Personal reasons" }}
              </p>
            </v-col> -->

            <v-col cols="6" class="pr-2 pt-2">
              <v-btn
                rounded
                large
                block
                outlined
                color="#757575"
                style="border: 2px solid #E0E0E0; color: #757575; text-transform: none; font-weight: bold; font-size: 15px; height: 48px;"
                @click="isDialogCancel = false; selectedNote = null; isboolNote = false"
              >
                {{ languageSelect === 0 ? "ปิด" : "Close" }}
              </v-btn>
            </v-col>
            <v-col cols="6" class="pl-2 pt-2">
              <v-btn
                rounded
                large
                block
                color="#D32F2F"
                dark
                style="text-transform: none; font-weight: bold; font-size: 15px; box-shadow: 0 2px 8px rgba(211, 47, 47, 0.3); height: 48px;"
                @click="cancelBooking"
              >
                {{ languageSelect === 0 ? "ยกเลิกนัดหมาย" : "Cancel Booking" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios' // api
import QrcodeVue from 'qrcode.vue'
import moment from 'moment'

export default {
  components: {
    name: '',
    QrcodeVue
  },
  data () {
    return {
      unsubscribe: null,
      loading: false,
      loadingCancel: false,
      textCheckQueue: '',
      textCheckQueueEng: '',
      languageSelect: 0,
      checkMemberId: '',
      value: '',
      size: 200,
      foreground: '#000000',
      profile: null,
      ColorByShop: [],
      DarkMode: '',
      DarkModeStatus: null,
      DarkModeButton: '',
      DarkModeBackground: '',
      DarkModefont: '',
      shop: [],
      LoGo: [],
      ImgCover: '',
      dataBookingList: [],
      dataBooking: [],
      dataBookingData: [],
      dataBookingDataUse: [],
      sequenceNo: 0,
      shopId: this.$route.query.shopId,
      bookNo: this.$route.query.bookNo,
      beforQueue: '',
      checkQueue: null,
      dataLineConfig: {},
      showTime: '',
      source: '',
      userId: '',
      forwardQueue: false,
      isDialogCancel: false,
      Note: [
        {
          reason: 'รอนานเกินไป',
          reason_en: 'Waited too long'
        },
        {
          reason: 'ไปไม่ทัน',
          reason_en: 'Unable to make it in time'
        },
        {
          reason: 'จองผิด',
          reason_en: 'Booked by mistake'
        },
        {
          reason: 'เหตุผลส่วนตัว',
          reason_en: 'Personal reasons'
        }
      ],
      selectedNote: null,
      NoteComment: null,
      isboolNote: false,
      customFieldData: []
    }
  },
  computed: {
    isVForCompleted () {
      return this.visibleBookingDataUse.length === 0
    },
    currentBooking () {
      return this.dataBookingData.length > 0 ? this.dataBookingData[0] : {}
    },
    showQueueCard () {
      return this.dataBookingData.length > 0 && this.currentBooking.storeFrontQueue && this.currentBooking.statusBt
    },
    queueCardStyle () {
      return 'background-color:#FFFFFF;min-height: 180px;border-radius: 0px 0px 45px 45px;border-top: 2px dotted ' + this.DarkModeBackground + ';position:relative'
    },
    isWesternHospital () {
      return this.shopNameData.krungthaiWesternHospital === this.shopId || this.shopNameData.krungthaiWesternHospitalPkm === this.shopId
    },
    isYamahaShop () {
      return this.shopNameData.yamaha === this.shopId
    },
    shouldShowBookingTime () {
      if (this.showTime !== 'แสดง') return false
      if (!this.isYamahaShop || this.dataBookingData.length === 0) return true
      return this.momenTime(this.dataBookingData[0].dueDate) !== '00:00'
    },
    isTerminalBookingStatus () {
      return ['finish', 'closed', 'success', 'cancel', 'cancelled', 'closeJob'].indexOf(this.currentBooking.BookingStatus) > -1 ||
        ['closeJob', 'cancel'].indexOf(this.currentBooking.statusBt) > -1
    },
    isForwardQueueContext () {
      if (!this.forwardQueue) return false
      return !!this.currentBooking.forwardQueueId || this.currentBooking.BookingStatus === 'forwarded'
    },
    isForwardQueueWaiting () {
      if (!this.isForwardQueueContext) return false
      if (this.isTerminalBookingStatus) return false
      return this.currentBooking.BookingStatus === 'forwarded' || this.currentBooking.statusBt === 'confirm'
    },
    isForwardQueueCalled () {
      if (!this.isForwardQueueContext) return false
      return this.currentBooking.statusBt === 'confirmJob' || !!this.currentBooking.call_queue_date_time
    },
    isQueueCalled () {
      return this.currentBooking.statusBt === 'confirmJob' ||
        !!this.currentBooking.call_queue_date_time ||
        this.isForwardQueueCalled
    },
    visibleBookingDataUse () {
      return this.dataBookingDataUse.filter(item => !this.shouldHidePosBookingField(item))
    },
    queueCardMessages () {
      // console.log('currentBooking', this.currentBooking)
      const statusBt = this.currentBooking.statusBt
      const bookingStatus = this.currentBooking.BookingStatus
      // const isYamahaPart = this.currentBooking.isYamahaPart
      const flowName = this.currentBooking.flowName
      const flowNameEn = this.currentBooking.flowName
      const waitingStatus = 'confirm'

      if (this.isTerminalBookingStatus) {
        if (this.currentBooking.BookingStatus === 'cancel' || this.currentBooking.BookingStatus === 'cancelled' || statusBt === 'cancel') {
          return {
            type: 'message',
            messages: [this.queueText('คิวของคุณถูกยกเลิกแล้ว', 'Your queue has been cancelled.')]
          }
        }
        return {
          type: 'message',
          messages: [this.queueText('เสร็จสิ้นแล้ว', 'Finished.')]
        }
      }

      if (this.isYamahaShop) {
        if (bookingStatus === 'confirm') {
          return {
            type: 'message',
            messages: [this.queueText('เข้ารับบริการแล้ว', 'Already checked in for service.')]
          }
        }

        if (bookingStatus === 'checkIn') {
          return {
            type: 'message',
            messages: [this.queueText('เช็คอิน', 'Checked in.')]
          }
        }

        if (bookingStatus === 'reported') {
          return {
            type: 'message',
            messages: [this.queueText('แจ้งปัญหา', 'Reported an issue.')]
          }
        }

        if (bookingStatus === 'closeJob') {
          return {
            type: 'message',
            messages: [this.queueText(flowName + 'เสร็จแล้ว', flowNameEn + ' is finished.')]
          }
        }

        if (bookingStatus === 'confirmJob') {
          return {
            type: 'message',
            messages: [this.queueText('เข้ารับบริการแล้ว', 'Already checked in for service.')]
          }
        }

        if (bookingStatus === 'payment') {
          return {
            type: 'message',
            messages: [this.queueText('ชำระเงิน', 'Payment.')]
          }
        }

        if (bookingStatus === 'success') {
          return {
            type: 'message',
            messages: [this.queueText('ปิดงานแล้ว', 'Job closed.')]
          }
        }

        if (bookingStatus === 'cancel') {
          return {
            type: 'message',
            messages: [this.queueText('ยกเลิก', 'Job cancelled.')]
          }
        }

        if (bookingStatus === 'skip' || bookingStatus === 'skip_cashier') {
          return {
            type: 'message',
            messages: [this.queueText('รอดำเนินการ', 'Pending.')]
          }
        }
      }

      if (this.isQueueCalled) {
        return {
          type: 'message',
          messages: [
            this.queueText('ถึงคิวของคุณแล้ว', 'Your queue has been called.'),
            this.queueText('กรุณาไปที่จุดบริการ', 'Please go to the service point.')
          ]
        }
      }

      if ((statusBt === waitingStatus || this.isForwardQueueWaiting) && this.beforQueue > 0) {
        return {
          type: 'beforeQueue',
          messages: []
        }
      }

      if (statusBt === null || statusBt === 'closeJob' || statusBt === 'cancel') {
        return {
          type: 'message',
          messages: [this.queueText('คิวของคุณถูกยกเลิกแล้ว', 'Your queue has been cancelled.')]
        }
      }

      if ((statusBt === waitingStatus || this.isForwardQueueWaiting) && this.beforQueue === 0) {
        return {
          type: 'message',
          messages: [
            this.queueText('ตอนนี้คุณอยู่คิวแรกแล้ว', 'You are now in the first queue.'),
            this.queueText('กรุณารอเจ้าหน้าที่เรียกคิว', 'Please wait for the staff to call the queue.')
          ]
        }
      }

      if (!this.forwardQueue && this.isWesternHospital) {
        return {
          type: 'message',
          messages: statusBt === 'holdJob' ? [this.queueText('รอผล Lab X-Ray', 'Waiting for lab X-ray results.')] : []
        }
      }

      if (statusBt === 'startLoad') {
        return {
          type: 'message',
          messages: [this.queueText('เริ่มโหลด', 'Start load')]
        }
      }

      if (statusBt === 'holdJob') {
        return {
          type: 'message',
          messages: [this.queueText('คิวถูกพัก', 'Queue is holded')]
        }
      }

      if (statusBt === 'returnCard') {
        return {
          type: 'message',
          messages: [this.queueText('คืนบัตรแล้ว', 'Card is returned')]
        }
      }

      return {
        type: 'message',
        messages: [
          this.queueText('บัตรคิวของคุณมีปัญหา', 'Your queue has a problem.'),
          this.queueText('กรุณาติดต่อเจ้าหน้าที่', 'Please contact the staff.')
        ]
      }
    }
  },
  created () {
    // this.getFirestore()
  },
  beforeDestroy () {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
  async mounted () {
    this.loading = true
    try {
      let hasForwardQueueQuery = false
      if (this.$route.query.forwardQueue === 'true') {
        this.forwardQueue = true
        hasForwardQueueQuery = true
      }
      if (this.$route.query.languageSelect) {
        this.languageSelect = parseInt(this.$route.query.languageSelect)
      } else {
        this.languageSelect = 0
      }
      if (this.$route.query.shopId && this.$route.query.bookNo) {
        this.shopId = this.$route.query.shopId
        if (this.$route.query.checkLine) {

        } else {
          let checkShopId = ''
          if (this.$route.query.shopId) {
            checkShopId = this.$route.query.shopId
          } else {
            const queryString = decodeURIComponent(window.location.search).replace(
              '?liff.state=',
              ''
            )
            console.log('queryString', queryString)
            const params = new URLSearchParams(queryString)
            checkShopId = params.get('shopId')
          }
          this.shopId = checkShopId
          this.dataLineConfig = await this.getDataLineConfig(checkShopId)
          await this.checkLiffLogin(this.dataLineConfig, false)
        }
        await this.getBookingField()
        await this.getShop(hasForwardQueueQuery)
        await this.getBookingData()
        await this.getBookingDataUse()
        await this.getCustomField()
      } else {
        this.$swal(
          'พบความผิดพลาดระหว่างดำเนินการ',
          'กรุณาติดต่อเจ้าหน้าที่',
          'info'
        )
      }
    } catch (error) {

    } finally {
      this.loading = false
    }
  },
  methods: {
    queueText (textTh, textEn) {
      return this.languageSelect === 0 ? textTh : textEn
    },
    normalizeText (value) {
      return (value || '').toString().trim().toLowerCase()
    },
    shouldHidePosBookingField (item) {
      const fieldName = this.normalizeText(item.fieldName)
      const fieldNameEn = this.normalizeText(item.fieldNameEn)
      const fieldValue = this.normalizeText(item.fieldValue)
      const isNameField = fieldName.includes('ชื่อ') || fieldNameEn.includes('name')
      const isPhoneField = fieldName.includes('เบอร์โทร') || fieldNameEn.includes('phone') || fieldNameEn.includes('tel') || fieldNameEn.includes('mobile')

      return (isNameField || isPhoneField) && (fieldValue.startsWith('pos') || fieldValue === '-')
    },
    async checkCancel () {
      this.loadingCancel = true
      await this.getBookingData()
      if (this.dataBookingData.length > 0 && this.dataBookingData[0].statusBt !== 'cancel' && this.dataBookingData[0].statusBt !== 'closeJob' && this.dataBookingData[0].storeFrontShowBt === 'True') {
        this.isDialogCancel = true
        this.loadingCancel = false
      } else {
        this.loadingCancel = false
        this.$swal(
          'ไม่สามารถยกเลิกนัดหมายได้',
          'นัดหมายของคุณถูกยกเลิกหรือเสร็จสิ้นแล้ว',
          'info'
        )
      }
    },
    async cancelBooking () {
      if (!this.selectedNote) {
        this.isboolNote = true
      } else {
        let body = {
          bookNo: this.bookNo,
          contactDate: moment().format('YYYY-MM-DD HH:mm'),
          status: 'cancel',
          cancelBy: 'user',
          statusUse: 'use',
          shopId: this.shopId,
          CREATE_USER: this.profile.userId, // line user id
          LAST_USER: this.profile.userId, // line user id
          remarkRemove: this.selectedNote.reason // เหมือนในรูป
        }
        console.log('body', body)
        await axios
          .post(this.DNS_IP + '/booking_transaction/add', body)
          .then(async response => {
            this.updateProcessShopNew()
            this.isDialogCancel = false
            this.getBookingData()
            this.$liff.closeWindow()
            console.log('response', response)
          }).catch(err => {
          // this.$router.push({ name: '404' })
            console.log(err.code, err.message)
          })
      }
    },
    async updateProcessShopNew () {
      try {
        let body = {
          shopId: this.shopId
        }
        await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessNew', body)
      } catch (error) {
        console.log('updateProcessShopNew error-> ', error)
      }
    },
    async getBookingField () {
      this.showTime = ''
      await axios
        .get(this.DNS_IP + '/BookingField/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          if (rs.status === false) {
            this.showTime = 'แสดง'
          } else {
            this.showTime = rs[0].showTime || 'แสดง'
          }
        })
    },
    async checkLiffLogin (dataLineConfig, isFlex) {
      console.log('dataLineConfig', dataLineConfig)
      await this.$liff
        .init({
          liffId: dataLineConfig.liffMainID
        })
        .then(async () => {
          if (process.env.NODE_ENV === 'development') {
            this.getProfile_dev()
          } else {
            if (!this.$liff.isLoggedIn()) {
              this.$liff.login({ redirectUri: window.location.href })
            } else {
              await this.getProfile(isFlex)
            }
          }
        })
        .catch(err => {
          // this.$router.push({ name: '404' })
          console.log(err.code, err.message)
        })
      // this.$liff.init({ 'liffId': liffId }, function (data) {})
    },
    async getProfile (isFlex) {
      let _this = this
      await this.$liff
        .getProfile()
        .then(async function (profile) {
          _this.profile = profile
          console.log('prod', _this.profile)
          // if (_this.$route.query.source === 'ohrich') {
          _this.checkMemberOhrich(isFlex)
          // }
        })
        .catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    getProfile_dev () {
      this.profile = this.$profile_dev
      console.log('dev', this.profile)
    },
    async getShop (hasForwardQueueQuery) {
      if (this.$route.query.shopId) {
        await axios.get(this.DNS_IP + '/sys_shop/get?shopId=' + this.$route.query.shopId).then(response => {
          let rs = response.data
          if (rs.length > 0) {
            this.shop = rs
            console.log('this.shop', this.shop)
            if (!hasForwardQueueQuery) {
              this.forwardQueue = rs[0].is_forwarding_queue === 'True' || rs[0].is_forwarding_queue === true
            }
            rs.forEach(v => {
              if (v.primaryColor) {
                this.ColorByShop.push(v.primaryColor, v.secondaryColor)
                this.DarkModeBackground = v.primaryColor
                this.DarkModeButton = v.secondaryColor
              } else {
                this.ColorByShop.push('#E1F3FF', '#FFFFFF')
                this.DarkModeBackground = '#FFFFFF'
                this.DarkModeButton = '#E1F3FF'
              }
              if (v.shopImge) {
                this.LoGo = v.shopImge
              } else {
                this.LoGo = require('@/assets/Thank.svg')
              }
              if (v.shopImageCover) {
                this.ImgCover = v.shopImageCover
              } else {
                if (v.category === 'ธุรกิจรถยนต์') {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                } else {
                  this.ImgCover = require('@/assets/Cover2.jpg')
                }
              }
              if (v.darkMode === 'True') {
                this.DarkMode = '#FFFFFF'
                this.DarkModefont = '#FFFFFF'
              } else {
                this.DarkMode = ''
                this.DarkModefont = '#173053'
              }
            })
            this.bookingthankText = rs[0].bookingthankText
            console.log('this.bookingthankText', this.bookingthankText)
          } else {
            this.shop = null
          }
        })
      } else {
        this.ColorByShop.push('#E1F3FF', '#FFFFFF')
        this.LoGo = require('@/assets/Thank.svg')
        this.DarkMode = ''
        this.DarkModefont = '#173053'
      }
    },
    async getBookingQueue () {
      const booking = this.dataBookingData[0]
      const activeFlowId = booking.currentFlowId || booking.activeFlowId || booking.flowId
      if (this.forwardQueue) {
        const url = this.DNS_IP + '/booking_forward_queue/getQueueTV?shopId=' + this.shopId + '&dueDate=' + booking.dueDateDay + '&masBranchID=' + booking.masBranchID + '&flowId=' + activeFlowId
        await axios.get(url).then(response => {
          const payload = response.data || {}
          const rows = payload.dataServiceForwardQueue || []
          const currentQueue = rows.find(item => item.bookNo === booking.bookNo)

          if (currentQueue) {
            this.$set(this.dataBookingData, 0, Object.assign({}, booking, currentQueue, {
              statusBt: currentQueue.status || booking.statusBt
            }))
          }

          const currentBooking = this.dataBookingData[0]
          const waitingRows = rows.filter(item => item.status === 'confirm')
          let dataFilterForwardQueue = []
          if (currentBooking.forwardQueueId) {
            dataFilterForwardQueue = waitingRows.filter(item => item.forwardQueueId === currentBooking.forwardQueueId)
          } else {
            dataFilterForwardQueue = waitingRows.filter(item => !item.forwardQueueId)
          }

          const findIndex = dataFilterForwardQueue.findIndex(item => item.storeFrontQueue === currentBooking.storeFrontQueue)
          if (findIndex > -1) {
            this.beforQueue = dataFilterForwardQueue.filter((item, key) => key < findIndex).length
            this.checkQueue = currentBooking.storeFrontQueue
          } else {
            this.beforQueue = 0
            this.checkQueue = 0
          }
        })
        return
      }
      let url = this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&dueDate=' + booking.dueDateDay + '&masBranchID=' + booking.masBranchID + '&flowId=' + activeFlowId + '&storeFrontQueue=is not null&statusBt=confirm'
      await axios
        .get(url)
        .then(async response => {
          let rs = response.data
          console.log('test', rs)
          if (rs.length > 0) {
            let dataFilterForwardQueue = []
            if (this.forwardQueue) {
              dataFilterForwardQueue = rs.filter(el => { return el.forwardQueueId === this.dataBookingData[0].forwardQueueId })
            } else {
              dataFilterForwardQueue = rs
            }
            if (dataFilterForwardQueue.filter((item, key) => item.storeFrontQueue === this.dataBookingData[0].storeFrontQueue).length > 0) {
              let findIndex = dataFilterForwardQueue.findIndex((item, key) => item.storeFrontQueue === this.dataBookingData[0].storeFrontQueue)
              console.log('findIndex', findIndex)
              this.beforQueue = dataFilterForwardQueue.filter((item, key) => key < findIndex).length
              console.log('this.beforQueue', this.beforQueue)
              this.checkQueue = this.dataBookingData[0].storeFrontQueue
            } else {
              this.checkQueue = 0
              console.log('this.beforQueue', this.beforQueue)
            }
          } else {
            this.checkQueue = 0
          }
        })
    },
    async getBookingData () {
      let dataBookingData = []
      await axios
        // .get(this.DNS_IP + '/BookingData/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        .get(this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            dataBookingData = rs
            if (dataBookingData.length > 0) {
              this.dataBookingData = dataBookingData
              if (this.dataBookingData[0].checkPushMessageQue === 'False') {
                let dttt = {
                  checkGetQueue: 'False'
                }
                await axios
                  .post(this.DNS_IP + '/Booking/pushMsgQueue/' + this.bookNo, dttt)
                  .then(async response => { }).catch(error => {
                    console.log('error function pushMsgQueue : ', error)
                  })
              }
            }
            await this.getBookingQueue()
          }
        }).catch(err => {
          console.log(err.code, err.message)
        })
    },
    async getBookingDataUse () {
      this.dataBookingDataUse = []
      await axios
        .get(this.DNS_IP + '/BookingData/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        // .get(this.DNS_IP + '/booking_view/get?shopId=' + this.shopId + '&bookNo=' + this.bookNo)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (let i = 0; i < rs.length; i++) {
              if (rs[i].multiSelect === 'True') {
                try {
                  // Check if fieldValue is already an array
                  let parsedValue = rs[i].fieldValue
                  if (typeof parsedValue === 'string') {
                    parsedValue = JSON.parse(parsedValue)
                  }
                  if (Array.isArray(parsedValue) && parsedValue.length > 0) {
                    rs[i].fieldValue = parsedValue.join(',')
                  } else {
                    rs[i].fieldValue = rs[i].fieldValue
                  }
                } catch (error) {
                  // If JSON.parse fails, keep the original value
                  console.log('Error parsing fieldValue:', error)
                  rs[i].fieldValue = rs[i].fieldValue
                }
              } else {
                rs[i].fieldValue = rs[i].fieldValue
              }
            }
            this.dataBookingDataUse = rs
          }
        })
    },
    async getCustomField () {
      this.customFieldData = []
      await axios
        .get(this.DNS_IP + '/customField/get?shopId=' + this.shopId)
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            this.customFieldData = rs
          }
          console.log('customFieldData', this.customFieldData)
        })
        .catch(error => {
          console.log('error function getCustomField : ', error)
        })
    },
    getFieldValueEn (item) {
      // ค้นหา custom field ที่ตรงกับ fieldName ของ item
      let matchField = this.customFieldData.find(f => f.fieldName === item.fieldName)
      if (matchField && matchField.optionField) {
        try {
          let options = JSON.parse(matchField.optionField)
          if (Array.isArray(options)) {
            // กรณี Checkbox หรือ multiSelect - fieldValue อาจเป็น array
            if (item.fieldType === 'Checkbox' || item.multiSelect === 'True') {
              try {
                let values = item.fieldValue
                if (typeof values === 'string') {
                  values = JSON.parse(values)
                }
                if (Array.isArray(values)) {
                  let engValues = values.map(v => {
                    let found = options.find(opt => opt.text === v || opt.value === v)
                    return found && found.textEng ? found.textEng : v
                  })
                  return engValues.join(',')
                }
              } catch (e) {
                // ถ้า parse ไม่ได้ ให้ลองหาแบบ single value
              }
            }
            // กรณี single value - เทียบ fieldValue กับ text หรือ value ใน options
            let found = options.find(opt => opt.text === item.fieldValue || opt.value === item.fieldValue)
            if (found && found.textEng) {
              return found.textEng
            }
          }
        } catch (e) {
          console.log('Error parsing optionField:', e)
        }
      }
      // ถ้าหาไม่เจอ ให้คืนค่า fieldValue เดิม
      return item.fieldValue
    },
    async checkMember (bookNo) {
      await axios.get(this.DNS_IP + '/booking_view/get?bookNo=' + bookNo)
        .then(async (response) => {
          let rs = response.data
          console.log('RSTESTTTTTT', response)
          if (rs[0].lineUserId === null || rs[0].lineUserId === '') {
            this.checkMemberId = 'memberNo'
          } else {
            this.checkMemberId = 'memberTrue'
          }
          console.log('this.checkMemberId', this.checkMemberId)
        }).catch(function (error) {
          console.log('Error getting profile: ' + error)
        })
    },
    async getBotinfo () {
      console.log('getBotinfo')
      if (this.$route.query.source === 'ohrich') {
        this.dataLineConfig = await this.getDataLineConfig(this.$route.query.shopId)
        await this.checkLiffLogin(this.dataLineConfig, true)
      } else {
        if (this.$route.query.shopId) {
          const url = `${this.DNS_IP}/line/getOa`
          // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
          const config = {
            headers: {
              'botId': this.$route.query.shopId
            }
          }
          await this.checkMember(this.$route.query.bookNo)
          await axios.get(url, config).then((response) => {
            let rs = response.data
            console.log('rs1111', rs)
            if (this.checkMemberId === 'memberNo') {
              // window.location.href = 'https://line.me/R/oaMessage/' + rs.basicId + `?เปิดรับการแจ้งเตือน ` + this.profile.userId
              window.location.href = 'https://line.me/R/oaMessage/' + rs.basicId + `/?เปิดรับการแจ้งเตือน`
              // liff.openliff.openWindow({
              //   url: 'https://line.me/R/oaMessage/' + rs.basicId + `?เปิดรับการแจ้งเตือน`,
              //   external: true
              // })
            } else {
              window.location.href = 'line://ti/p/' + rs.basicId
            }
          })
        }
      }
    },
    async checkMemberOhrich (isFlex) {
      await this.saveUserId()
      await axios.get(this.DNS_IP + '/member/get?shopId=' + this.$route.query.shopId + '&liffUserId=' + this.profile.userId).then(async result => {
        var lineUserIds = ''
        var liffUserIds = ''
        if (result.data.status === false) {
          await this.onSubmit()
        } else {
          lineUserIds = result.data[0].lineUserId || ''
          liffUserIds = result.data[0].liffUserId || ''
          if (lineUserIds === '' && liffUserIds !== '') {
            await this.onUpdate(result.data[0].memberId)
          }
        }
        if (isFlex) {
          let dttt = {
            checkGetQueue: 'False',
            firstSend: 'True'
          }
          await axios
            .post(this.DNS_IP + '/Booking/pushMsgQueue/' + this.$route.query.bookNo, dttt)
            .then(async response => { }).catch(error => {
              console.log('error function pushMsgQueue : ', error)
            }).catch(error => {
              console.log('error function pushMsgQueue : ', error)
            })
        }
      }).catch(error => {
        console.log('error function member get : ', error)
      })
    },
    async saveUserId () {
      let userId = {
        'userId': this.profile.userId
      }
      await axios.post(this.DNS_IP + '/Booking/edit/' + this.$route.query.bookNo, userId).then(async response => {
        console.log('response', response)
      }).catch(error => {
        console.log('error function saveUserId : ', error)
      })
    },
    async onSubmit () {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        lineUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        memberId: idMember,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', `/member/add`, params)
      console.log('result', result.status)
      // if (this.shopNameData.krungthaiWesternHospital === this.shopId) {
      //   await this.updateProcessShopNew()
      // }
    },
    async onUpdate (idMember) {
      // "https://api-belinked.betaskthai.com/member/editWebhook/" + request.body.events[0].message.text.split(" ")[2]
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      const params = {
        lineUserId: this.profile.userId,
        liffUserId: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const result = await this.callBeTaskAPIActivity('post', '/member/editWebhook/' + idMember, params)
      console.log('result', result.status)
      // if (this.shopNameData.krungthaiWesternHospital === this.shopId) {
      //   await this.updateProcessShopNew()
      // }
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.log(error)
        result = null
      })
      return result
    },
    async getBotinfoChatAuto () {
      console.log('getBotinfoChatAuto')

      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        // const url = 'http://localhost:81/Api/vgroupl_api/v1/Zoom/Login/getData?'
        const config = {
          headers: {
            'botId': this.$route.query.shopId
          }
        }
        await axios.get(url, config).then((response) => {
          let rs = response.data
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    }
    // async getFirestore () {
    //   try {
    //     console.log('getFirestore -> ', this.unsubscribe)
    //     if (this.unsubscribe) {
    //       this.unsubscribe()
    //     }
    //     this.firestore = this.$firebase.firestore()
    //     this.unsubscribe = this.firestore.collection(`QueueOnline/shopId/${this.shopId}`).doc(this.bookNo)
    //       .onSnapshot(async (snapshot) => {
    //         if (!snapshot.exists) {
    //           await this.updateProcessWebNew()
    //         } else {
    //           console.log('getFirestore -> data', snapshot.data())
    //           if (snapshot.data().active === '1') {
    //             console.log('active [start] is updateProcessShopUpdate')
    //             await this.updateProcessShopUpdate()
    //             console.log('active [end] is updateProcessShopUpdate')
    //             console.log('snapshot data -> active is 1')
    //             console.log('active [start] is get booking')
    //             await this.getBookingData()
    //             console.log('active [end] is get booking')
    //           } else {
    //             console.log('snapshot data -> active is 0')
    //           }
    //         }
    //       })
    //   } catch (error) {
    //     console.log('Error getFirestore', error)
    //   }
    // },
    // async updateProcessWebNew  () { // active = 1
    //   try {
    //     let body = {
    //       userName: this.bookNo,
    //       shopId: this.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-CreateProcessNew', body)
    //   } catch (error) {
    //     console.log('updateProcessWebNew error-> ', error)
    //   }
    // },
    // async updateProcessShopUpdate  () { // active = 0
    //   try {
    //     let body = {
    //       userName: this.bookNo,
    //       shopId: this.shopId
    //     }
    //     await axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/QueueOnline-ProcessUseNew', body)
    //   } catch (error) {
    //     console.log('updateProcessShopUpdate error-> ', error)
    //   }
    // }
  }
}
</script>

<style scoped>
.main {
  background-color: #ffffff;
  height: 100vh;
}

.content {
  overflow: auto;
  white-space: normal;
}

.a {
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 10px;
  max-height: 350px;
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/CheckQueueStoreFront.vue